import React, { useMemo } from "react";
import { KBArticlesData } from "./kb.articles.data";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { SimpleWidget } from "@me8eon/simple_widget";
import { ThemedIcon } from "@me8eon/icons"
import { useCommonComponents } from "@me8eon/components";
import { decodeHTML } from "@me8eon/string_utils";
import { getFormattedDateTime, parseCustomDate } from "@me8eon/time";

export const KBArticlesDisplay: DisplayData<KBArticlesData> =
    ({ rootId, id, data }: DisplayDataProps<KBArticlesData>) => {
        const { ClipHeight } = useCommonComponents();
        const { H1WithIconAndUrl, Markdown, Url } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const title = decodeHTML(data.short_description);
        const description = data.text ? data.text?.replace(/<[^>]+>/g, ' ').replace(/\n/g, ' ') : data.text;
        const issueSummaryAndUrl = useMemo(() =>
            ({ url: data.url, title: title, icon: () => <ThemedIcon name="itSupport" /> }), [data.url, title]);

        return <DataLayout rootId={newRootId} className='order-it-data' layout={[1, 1, 2, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
            {description !== 'undefined' ? <ClipHeight maxHeight='2rem' force={false}>
                <Markdown rootId={id} attribute={translateLabelForData('data.description')} value={description} />
            </ClipHeight> : <></>}
            <Text rootId={id} attribute={translateLabelForData('category')} value={data.kb_category} />
            <Text rootId={id} attribute={translateLabelForData('lastUpdated')} value={getFormattedDateTime(new Date(parseCustomDate(data.sys_updated_on)), 'Y-m-d')} />
            <Url rootId={id} attribute={translateLabelForData('url')} value={data.url} />
        </DataLayout>;
    };

export const SimpleKBArticlesOneLineDisplay: DisplayData<KBArticlesData> =
    ({ data, listItemClicked }: DisplayDataProps<KBArticlesData>) => {
        const { SearchListItem } = useRenderers();

        const issueSummaryAndUrl = useMemo(() =>
        ({
            title: data.short_description,
            icon: () => <ThemedIcon name="itSupport" />,
            onClick: () => { listItemClicked && listItemClicked(data.short_description) }
        }), [data.short_description]);


        return (
            <SearchListItem key={data.short_description} rootId={data.short_description} attribute={translateLabelForData('name')} value={issueSummaryAndUrl} />
        )
    }
export const SimpleKBArticlesWidget: DisplayDataWidget<KBArticlesData> =
    SimpleWidget(
        ['name', 'description'],
        ['short_description', 'text'],
        ['id']);

